<section class="public-profile team-section">
  <div class="container">
    <div class="container-wrap">
      <div class="bg-wrap">
        <div class="top-ba"></div>

        <div class="profile-wrap" *ngIf="team">
          <div class="ba">
            <img [src]="team && team.banner ? team.banner : ''" width="100%" [alt]="team.name" />
          </div>

          <div class="avatar">
            <p>{{'PUBLIC_PROFILE.DONATE_DIRECTLY_TO' | translate}}</p>
            <div class="img-wrap">
              <img [ngSrc]="team && team.avatar ? team.avatar : '../../../assets/images/icons/player.png'" fill loading="lazy" [alt]="team.name" />
            </div>
          </div>

          <div class="name">
            <h1>{{team.name}}</h1>
          </div>

          <div class="description" *ngIf="!pickupRequestCompleted; else successMessage">
            <p>{{team.description}}</p>
          </div>

          <ng-template #successMessage>
            <div class="description success">
              <h3>{{'PUBLIC_PROFILE.SUCCESS_TEAM_TITLE' | translate: { team_name: team.name } }}</h3>
              <p>{{'PUBLIC_PROFILE.SUCCESS_TEAM_DESCRIPTION' | translate}}</p>
            </div>
          </ng-template>

          <div class="button-wrap" *ngIf="!pickupRequestCompleted">
            <button class="btn btn-primary" (click)="openPickupRequestForm(true)">{{'PUBLIC_PROFILE.DONATE_TO_PLAYER' | translate}} {{team.name}}</button>
          </div>
        </div>
      </div>

      <div class="profile-footer">
        <div class="players-wrap" *ngIf="team && team.players && team.players.length > 0 && !pickupRequestCompleted">
          <h2>{{'PUBLIC_PROFILE.PLAYERS_TITLE' | translate}}</h2>

          <ul>
            <li *ngFor="let player of team.players">
              <div class="player-avatar-name-wrap">
                <a [routerLink]="['/', currentLang, 'players', player.public_id]" class="player-avatar">
                  <img [ngSrc]="player && player.avatar ? player.avatar : '../../../assets/images/icons/player.png'" fill loading="lazy"  alt="">
                </a>
                <div class="player-name">
                  <a [routerLink]="['/', currentLang, 'players', player.public_id]">
                    <h4>{{player.first_name}} {{player.last_name}}</h4>
                  </a>
                </div>
              </div>
              <div class="player-btn">
                <button class="btn" (click)="openPickupRequestForm(false, player)">{{'PUBLIC_PROFILE.SCHEDULE_PICKUP' | translate}}</button>
              </div>
            </li>
          </ul>
        </div>

        <div class="download-app-info">
          <div class="download-app-title">
            <h4>{{'PUBLIC_PROFILE.DOWNLOAD_APP_TITLE' | translate}}</h4>
          </div>
          <div class="buttons-wrap">
            <a [href]="storeLinks.GIPANT.appStore" class="store-btn apple" target="_blank"></a>
            <a [href]="storeLinks.GIPANT.googlePlay" class="store-btn android" target="_blank"></a>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>


<ngx-smart-modal #pickupRequestModal identifier="pickupRequestModal" [customClass]="'pickup-request-modal'" [dismissable]="false">
  <app-pickup-request-form *ngIf="donateTo" [modalMode]="true" [donateToData]="donateTo" (success)="onPickupRequestSuccess()"></app-pickup-request-form>
</ngx-smart-modal>
